const pt_PT = {
    homepage_title: 'Descarregar CalendarTask versão mobile com código QR',
    homepage_slogn: 'CalendarTask versão mobile',
    homepage_ios_download: 'App Store em revisão...',
    homepage_download: 'Descarregar',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Descarregar CalendarTask versão mobile com código QR',
    phonedownload_slogan: 'Sincronize com PC e tablet, anote em qualquer lugar',
    phonedownload_send_vip: 'Instale a app e receba assinatura VIP',
    phonedownload_screenshot: 'Captura de ecrã',
    phodedownload_macos: 'CalendarTask versão macOS',
    phodedownload_windows: 'CalendarTask versão Windows',
    phodedownload_otherbutton: 'Ver agora',
    phodedownload_about: 'Contacto',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Sem anúncios',
    feature_easy: 'Vista mensal, simples e fácil',
    feature_reminder: 'Lembrete personalizado',
    feature_countdown: 'Contagem decrescente aniversário',

    vip_task_succ: 'Sucesso. Descarregue a app para ativar VIP',
    vip_task_error: 'Receção falhada',

    group_slogn: 'Convite CalendarTask equipa',

    tt_title: 'CalendarTask',
    tt_share_1: 'Partilhado consigo',
    tt_share_2: 'Horário',
    tt_share_show_1: 'Digitalize o código QR com a app "CalendarTask", PC e telemóvel mostrarão',
    tt_share_show_2: 'o horário',
    tt_share_scan_1: 'Digitalizar com',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Sincronização bem-sucedida',

    v2_copyright: 'Contacto service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Todos os direitos reservados.',
    v2_download_appstore: 'Descarregar na App Store',
    v2_download_googleplay: 'Disponível no Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Pesquise <span class="name">CalendarTask</span> na App Store ou Google Play',
    v2_download_ios: 'Descarregar iOS',
    v2_download_android: 'Descarregar Android',
    v2_download_harmonyos: 'Descarregar HarmonyOS',
    v2_sync_status: 'Sincronização concluída! 1 carregado, 0 descarregados',
    v2_feature_title: 'Sincronização multi-dispositivo',
    v2_feature_description: 'Sincronização entre telemóvel, tablet e PC'
};
export default pt_PT;
